import "./Entry.scss";
import checkerLogo from "static/images/checker_logo.svg";

const EntryWrap = ({ children }) => {
  return (
    <div className="entry">

      <div className="entry-container">
        <div className="entry-left">
          <div className="entry-logo">
            <img
              src={checkerLogo}
              alt="logotype"
              className="entry-logo__logo"
            />
          </div>
          {children}
        </div>

        <div className="entry-right"></div>
      </div>
    </div>
  );
};

export default EntryWrap;
